<ion-header>
  <ion-toolbar color="light">
    <ion-buttons slot="start">
      <ion-button (click)="dismiss('close')">
        <ion-icon name="arrow-back-circle-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-title>Políticas</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-segment (ionChange)="segmentChanged($event)" [value]="initialPage">
    <ion-segment-button value="terms">
      <ion-label class="buttons"> Condiciones </ion-label>
    </ion-segment-button>
    <ion-segment-button value="privacy">
      <ion-label class="buttons"> Privacidad </ion-label>
    </ion-segment-button>
    <ion-segment-button value="about">
      <ion-label class="buttons"> Acerca de </ion-label>
    </ion-segment-button>
  </ion-segment>

  <ng-container *ngIf="initialPage === 'terms'">
    <h4 class="ion-text-center">Términos y condiciones del servicio</h4>
    <div class="" [innerHtml]="terms | safeHtml"></div>
  </ng-container>

  <ng-container *ngIf="initialPage === 'privacy'">
    <h4 class="ion-text-center">Políticas de privacidad</h4>
    <div class="" [innerHtml]="privacy | safeHtml"></div>
  </ng-container>
  <ng-container *ngIf="initialPage === 'about'">
    <h4 class="ion-text-center">Acerca de</h4>
    <div class="" [innerHtml]="aboutUs | safeHtml"></div>
  </ng-container>
</ion-content>
